import { GENERATION_TOOL } from 'src/data/generationTool';
import { classifyTemplate } from 'src/graphql/project';

import { extractTemplate, extractToolList, isPromptInvalid } from './utils';

export const prepareTemplateClassifier = ({ templates, customerId, editorType }) => {
  return async ({ allInstructionsData, urlExtractions }) => {
    const toolList = extractToolList({ templates, editorType });

    const tool = await classifyTemplate({
      toolList,
      customerId,
      urlExtractions,
      allInstructionsData,
    });
    if (!tool) {
      return {
        name: null,
        subTemplateId: null,
        isInvalidPrompt: false,
        generationTool: GENERATION_TOOL.freestyle,
      };
    }

    if (isPromptInvalid(tool)) return { isInvalidPrompt: true };

    const template = extractTemplate({ tool, templates, toolList, editorType });

    if (template) {
      return { ...template, isInvalidPrompt: false };
    }

    return {
      name: null,
      subTemplateId: null,
      isInvalidPrompt: false,
      generationTool: GENERATION_TOOL.freestyle,
    };
  };
};
